// libraries
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

// auth
import SignUp from '../components/';
import {saveUrlParameters} from '../../shared/actions/url-parameters';

// shared
import {
  setNavigationAnnouncement
} from 'shared/actions/accessibility-announcement';

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({
    setNavigationAnnouncement,
    saveUrlParameters
  }, dispatch)
);

export default connect(
  null,
  mapDispatchToProps
)(SignUp);
